module.exports = __webpack_public_path__ + "img/hairsalon.41213c6e.png";